module.exports = __webpack_public_path__ + "assets/img/bg_bubble.6026ae6d.png";